import React, { useMemo, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import AddStatusMaster from "./AddStatusMaster"
import EditStatusMaster from "./EditStatusMaster"
import { deleteNow } from "helpers/delete_function"
import { axiosbaseurl } from "configure"
import { setUpdatedData } from "helpers/data_setters"
import moment from "moment"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"
import { designation_options } from "constants/layout"
import { customStyles } from "helpers/select-styles"
import Select from "react-select"
import { Popover } from "antd"

const AllStatusMaster = ({ heading, api_name, type, module_id }) => {
  const [table_data, settable_data] = useState([])
  const [loading, setLoading] = useState(false)
  const [services, setServices] = useState([])

  useEffect(() => {
    const getStatus = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get(`/${api_name}`)
        if (response.data.success) {
          settable_data(response.data.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    async function fetchServices() {
      try {
        const response = await axiosbaseurl.get(`/service-master/active`)
        if (response.data.success)
          setServices(
            response.data.data
              .filter(
                item =>
                  item.serviceCategory === "Billiable and scheduled" ||
                  item.serviceCategory === "Non-Billiable and scheduled"
              )
              .map(service => ({
                value: service.id,
                label: service.serviceName,
              }))
          )
      } catch (error) {
        console.log(error)
      }
    }
    getStatus()
    fetchServices()
  }, [])

  document.title = `${heading} | Peacock Accountants Limited`

  return (
    <>
      {loading && <Loader />}
      <TableComponent
        table_data={table_data}
        services={services}
        settable_data={settable_data}
        heading={heading}
        api_name={api_name}
        type={type}
        module_id={module_id}
      />
    </>
  )
}

const TableComponent = ({
  table_data,
  settable_data,
  services,
  heading,
  api_name,
  type,
  module_id,
}) => {
  const [addShow, setAddShow] = useState(false)
  const [editShow, setEditShow] = useState(false)
  const [statusId, setStatusId] = useState("")

  const navigate = useNavigate()

  const { checkAccess, permissions } = usePermissionData()

  const handleStatus = async (status, id) => {
    try {
      if (status) {
        const response = await axiosbaseurl.patch(`/${api_name}/${id}/status`, {
          status,
        })
        if (response.data.success) {
          settable_data(
            setUpdatedData(
              table_data,
              response.data.data,
              "edit",
              "Designation "
            )
          )
        }
      }
    } catch (error) {
      console.log(error)
      const msg =
        error?.response?.data?.message ||
        error.message ||
        "Something went Wrong"
      swal("", msg, "error")
    }
  }

  const handleUpdateDesignations = async (designations = [], id) => {
    try {
      const designation = JSON.stringify(designations.map(des => des.value))
      const response = await axiosbaseurl.put(
        `/${api_name}/designation/${id}`,
        {
          designation,
        }
      )
      if (response.data.success) {
        settable_data(
          setUpdatedData(table_data, response.data.data, "edit", "Designation ")
        )
      }
    } catch (error) {
      console.log(error)

      const msg =
        error?.response?.data?.message ||
        error.message ||
        "Something went Wrong"
      swal("", msg, "error")
    }
  }

  // const handleDelete = async id => {

  //   try {
  //     const response = await axiosbaseurl.delete(`/${api_name}/${id}`)
  //     if (response.data.success)
  //       settable_data(setUpdatedData(table_data, response.data.data, "delete"))
  //   } catch (error) {
  //     console.log(error)
  //     swal("", error.response.data.message || "Something went Wrong", "error")
  //   }
  // }

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: " text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Status Name",
        accessor: "statusName",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          return (
            <div className="text-center">
              <span
                className="px-2 py-1 badge rounded text-white"
                style={{
                  backgroundColor: cellProps.row.original.colorCode,
                  fontWeight: 500,
                }}
              >
                {cellProps.row.original.statusName}{" "}
              </span>
            </div>
          )
        },
      },
      {
        Header: "Sort Order",
        accessor: "sortOrder",
        disableFilters: true,
        filterable: true,
        className: " text-center",
      },

      ...(module_id !== 9
        ? [
            {
              Header: "Created At",
              accessor: "createdAt",
              disableFilters: true,
              filterable: true,
              // className: " text-center",
              Cell: cellProps => {
                return (
                  <span>
                    {moment(cellProps.row.original.createdAt).format(
                      "DD MMM YYYY | hh:mm A"
                    )}
                  </span>
                )
              },
            },
          ]
        : []),

      // only for task status
      ...(module_id === 9
        ? [
            {
              Header:
                "Useable on Billable Scheduled/Non-Billable Scheduled Services",
              accessor: "serviceIds",
              disableFilters: true,
              filterable: true,
              className: "text-center",
              Cell: cellProps => {
                const currentServiceIds =
                  cellProps.row.original.serviceIds || []

                const selectedOptions = currentServiceIds
                  .map(id => {
                    const found = services.find(s => s.value === id)
                    return found || { value: id, label: `ID: ${id}` }
                  })
                  .filter(Boolean)

                return (
                  <div style={{ minWidth: "250px" }}>
                    <Select
                      value={selectedOptions}
                      onChange={async selected => {
                        const selectedIds = selected
                          ? selected.map(s => s.value)
                          : []

                        try {
                          const response = await axiosbaseurl.put(
                            `/${api_name}/services/${cellProps.row.original.id}`,
                            {
                              serviceIds: selectedIds,
                            }
                          )

                          if (response.data.success) {
                            // Update table data
                            settable_data(prev =>
                              prev.map(item =>
                                item.id === cellProps.row.original.id
                                  ? { ...item, serviceIds: selectedIds }
                                  : item
                              )
                            )
                          }
                        } catch (error) {
                          console.error(error)
                          swal("", "Failed to update services", "error")
                        }
                      }}
                      options={services}
                      styles={customStyles}
                      isMulti
                      placeholder="Select services..."
                      closeMenuOnSelect={false}
                      menuPortalTarget={document.body} // ← This is the key fix
                      menuPosition="fixed" // ← Recommended with portal
                    />
                  </div>
                )
              },
            },
          ]
        : []),

      {
        Header: "Status",
        disableSort: true,
        accessor: "status",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          return (
            <div className="text-center">
              <select
                onChange={e =>
                  handleStatus(e.target.value, cellProps.row.original.id)
                }
                disabled={!checkAccess(module_id, "edit")}
                className={`badge fs-6 border-0 status_select_dropdown 
                                bg-${
                                  cellProps.row.original.status == "Active"
                                    ? "green"
                                    : "danger"
                                }`}
                value={cellProps.row.original.status}
              >
                <option value="Active">Active</option>
                <option value="InActive">InActive</option>
              </select>
            </div>
          )
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        disableSort: true,
        accessor: "view",
        className: " text-center",
        Cell: cellProps => {
          const { id, designation } = cellProps.row.original
          const designations = JSON.parse(designation || "[]")?.map(des => ({
            label: des,
            value: des,
          }))
          return (
            <div>
              {checkAccess(module_id, "edit") && (
                <>
                  <button
                    onClick={() => {
                      setStatusId(id)
                      setEditShow(true)
                    }}
                    className="btn btn-success bg-green btn-sm"
                  >
                    <i className="fas fa-pen"></i>
                  </button>
                  {
                    // for task status
                    module_id === 9 && (
                      <Popover
                        placement="bottomLeft"
                        content={
                          <div className="p-3 pt-2" style={{ width: "400px" }}>
                            <Select
                              value={designations}
                              onChange={e => handleUpdateDesignations(e, id)}
                              options={designation_options}
                              styles={customStyles}
                              isMulti
                            />
                          </div>
                        }
                        title={`Designations`}
                        trigger="hover"
                      >
                        <button className="btn btn-sm btn-outline-primary ms-2">
                          <i className="fas fa-users me-1"></i> Designation
                        </button>
                      </Popover>
                    )
                  }
                </>
              )}

              {/* {checkAccess(module_id, "remove") && (
                <button
                  onClick={() => {
                    const notAllowed = [2, 3];

                    if (notAllowed.includes(cellProps.row.original.id) && api_name === 'client-status') {
                      swal("",
                        "Unable to delete the status, it is linked with Task and AutoTask generation module.",
                        "warning")
                      return;
                    }

                    deleteNow(() => handleDelete(cellProps.row.original.id))
                  }
                  }
                  className="btn btn-danger btn-sm ml-10"
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              )} */}
            </div>
          )
        },
      },
    ],
    [table_data, permissions]
  )

  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable columns={columns} data={data} heading={heading}>
          <div>
            {checkAccess(module_id, "add") && (
              <button
                onClick={() => setAddShow(true)}
                className="btn btn-primary bg-blue ms-3"
              >
                <i className="fas fa-plus me-2"></i>
                Add {type} Status
              </button>
            )}

            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>

        <AddStatusMaster
          show={addShow}
          setShow={setAddShow}
          settable_data={settable_data}
          api_name={api_name}
          type={type}
        />

        <EditStatusMaster
          show={editShow}
          setShow={setEditShow}
          settable_data={settable_data}
          statusId={statusId}
          setStatusId={setStatusId}
          api_name={api_name}
          type={type}
        />
      </PermittedComponent>
    </>
  )
}

export default AllStatusMaster
